/*
 * Copyright (c) 2025 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from '@irian-ro/abstract-resource';

export class TaskCheckpointState extends JSONable {
  canHandover: boolean | undefined = undefined;
  canReturn: boolean | undefined = undefined;
}
